import dynamic from 'next/dynamic';

const GoldCardDynamic = dynamic(
  async () => import('./index').then((m) => m.GoldCard),
  {
    ssr: false,
    loading: () => null,
  }
);

export { GoldCardDynamic };
